import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { UPDATE_INVOICE_NUMBER } from "../../helpers/constants/apiUrl";

const updateInvoiceNumber = (id,payload) => {
  return new Promise((res, rej) => {
    const url = `${UPDATE_INVOICE_NUMBER}/${id}/`; // Append the id to the URL
    triggerSimpleAjax(
      url,
      'PATCH',
      payload,  // Pass the payload as the request body
      (response) => {
        res(response);
      },
      (err) => {
        rej(err);
      }
    );
  });
};

export default updateInvoiceNumber;
